"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIconBase = _interopRequireDefault(require("react-icon-base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
class FaAmazon extends _react.default.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement(_reactIconBase.default, _extends({
      viewBox: "0 0 40 40"
    }, this.props), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
      d: " M 0.00 6.99 C 2.08 7.00 4.16 7.00 6.24 7.00 C 8.95 13.39 11.50 19.84 14.22 26.22 C 15.11 24.13 15.96 22.03 16.82 19.92 C 15.13 15.59 13.28 11.32 11.55 7.01 C 13.64 7.00 15.74 6.99 17.83 7.00 C 18.55 8.73 19.28 10.46 20.00 12.19 C 20.72 10.46 21.45 8.74 22.17 7.01 C 24.26 6.99 26.36 7.00 28.45 7.01 C 26.72 11.32 24.87 15.59 23.18 19.92 C 24.04 22.03 24.89 24.14 25.79 26.23 C 28.51 19.83 31.02 13.34 33.81 6.96 C 35.88 6.99 37.94 7.02 40.00 7.03 L 40.00 7.27 C 36.19 16.13 32.64 25.11 28.89 34.00 C 26.77 34.05 24.65 34.00 22.53 33.88 C 21.75 31.75 20.89 29.66 20.00 27.59 C 19.11 29.67 18.25 31.77 17.46 33.89 C 15.34 34.00 13.22 34.05 11.10 34.00 C 7.37 25.07 3.73 16.09 0.00 7.16 L 0.00 6.99 Z"
    })));
  }
}
exports.default = FaAmazon;